import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import type * as React from 'react'
import { cn } from '@/lib/utils'

export const TooltipProvider = TooltipPrimitive.Provider
export const Tooltip = TooltipPrimitive.Root
export const TooltipTrigger = TooltipPrimitive.Trigger

export function TooltipContent({
  className,
  sideOffset = 6,
  ...props
}: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          // No enter/exit animation classes here on purpose: they would need
          // tw-animate-css, and an unknown utility in Tailwind v4 fails
          // silently rather than loudly. A tooltip that appears instantly is
          // better than one that was supposed to fade and does not.
          'z-50 max-w-xs rounded-md border border-line bg-surface px-2.5 py-1.5 text-xs text-ink shadow-[var(--shadow-pop)]',
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
}
